import React from 'react';
import BioAgeReports from '../components/business/BioAgeReports';

export const ReportsCtx = React.createContext({});

function ReportsPageProvider(props) {
  const ctx = {};

  return (
    <ReportsCtx.Provider value={ ctx }>
      {props.children}
    </ReportsCtx.Provider>
  );
}

function BioAgeReportsPage() {
  return (
    <ReportsPageProvider>
      <BioAgeReports />
    </ReportsPageProvider>
  );
}

export default BioAgeReportsPage;
